import { NgModule, inject } from '@angular/core';
import { CDC_FEATURE, CdcConfig, CdcRootModule } from '@spartacus/cdc/root';
import { CmsConfig, provideConfig, provideConfigFactory } from '@spartacus/core';
import { CDCConstants } from '../../../../../src/app/constant/gigyaConstant';
import { EnvironmentService } from '../../../features/services/environment.service';

@NgModule({
  declarations: [],
  imports: [CdcRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CDC_FEATURE]: {
          module: () => import('@spartacus/cdc').then((m) => m.CdcModule),
        },
      },
    }),
    provideConfigFactory(cdcConfigFactory),
  ],
})
export class CdcFeatureModule {}

function cdcConfigFactory() {
  //const platformId = inject(PLATFORM_ID);
  //const isBrowser = isPlatformBrowser(platformId);

  // let apikey = prod.cdc.apikeyHisenseSI;
  //
  // if(isBrowser) {
  //   const hostName = location.hostname;
  //   if ( hostName === 'hisense-si-stg-hybris.gorenje.com') {
  //     apikey = staging.cdc.apikeyHisenseSI;
  //   } else if(hostName === 'localhost') {
  //     apikey = environment.cdc.apikeyHisenseSI;
  //   }
  // }

  const cdcConfig: CdcConfig = {
    cdc: [
      {
        baseSite: 'hisense-si',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-si'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-hr',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-hr'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-rs',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-rs'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-ro',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-ro'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-hu',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-hu'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-bg',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-bg'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-mk',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-mk'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-ba',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-ba'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-ua',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-ua'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-pl',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-pl'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-de',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-de'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-al',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-al'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-cz',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-cz'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-sk',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-sk'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-at',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-at'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-kz',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-kz'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-fi',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-fi'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-no',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-no'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-se',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-se'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-dk',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-dk'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-uk',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-uk'],
        sessionExpiration: 3600,
      },
      {
        baseSite: 'hisense-it',
        javascriptUrl:
          CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-it'],
        sessionExpiration: 3600,
      },
      // {
      //   baseSite: 'hisense-gr',
      //   javascriptUrl:
      //     CDCConstants.EuDataCenter + inject(EnvironmentService).getCurrentEnvironment().cdc.apiKey['hisense-gr'],
      //   sessionExpiration: 3600,
      // },
    ],
  };
  return cdcConfig;
}
